import * as jotai from 'jotai'

import * as api from '@owl-nest/api-client/next'
import * as hooks from '@owl-nest/hooks'

type DropoffPointsParams = {
  projectId: string
  payload: api.ProjectDropoffPointsRequest
}

export async function get(idOrSlug: string | number, payload: api.ProjectDropoffPointsRequest) {
  const response = await api.client('POST /projects/:id/dropoff-points', {
    urlParams: { id: String(idOrSlug) },
    body: payload,
  })
  return response.next((success) => success.body)
}

type DropoffPointsConfig = {
  fetchOnMount?: boolean | 'force'
  payload?: api.ProjectDropoffPointsRequest
}

const DROPOFFPOINTS_CACHE = jotai.atom<hooks.Cache<api.ProjectDropoffPointsResponse>>({})

export function useDropoffPoints(idOrSlug: string | number, { fetchOnMount = true, payload }: DropoffPointsConfig) {
  const sharedQuery = hooks.useSharedQuery(get, {
    atom: DROPOFFPOINTS_CACHE,
    id,
  })

  hooks.useFetchOnMount(
    {
      fetchOnMount,
      query,
      getResponse,
    },
    id(idOrSlug, payload),
  )

  return { response: getResponse(), query }

  function getResponse(): hooks.Response<api.ProjectDropoffPointsResponse> {
    if (payload === undefined) {
      return { status: hooks.QueryStatus.PRISTINE }
    }

    const response = sharedQuery.getCurrentResponse([idOrSlug, payload])

    return response as hooks.Response<api.ProjectDropoffPointsResponse>
  }

  function id(idOrSlug: string | number, payload: api.ProjectDropoffPointsRequest | undefined): string {
    return JSON.stringify([idOrSlug, payload])
  }

  async function query() {
    if (payload === undefined) {
      return
    }

    return sharedQuery.query(idOrSlug, payload)
  }
}
